<div id="main-content">

    <!-- Breadcrumb on the left -->
    <nav aria-label="breadcrumb" class="px-5 mb-0">
        <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a [routerLink]="['/home']">Workspaces</a></li>
            <li class="breadcrumb-item active" aria-current="page">Visual</li>
        </ol>
    </nav>
  
    <!-- Centered text -->
    <div class="flex-grow-1 d-flex justify-content-center">
        <p class="fs-5 mb-4 text-center">{{workspaceName}}</p>
    </div>

    <div id="graph-container" 
        class="graph-container" 
        (wheel)="onZoom($event)" 
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mouseup)="onMouseUp()"
        (mouseleave)="onMouseUp()">
        
        <!-- Mermaid chart container -->
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
        <div id="mermaidContainer" class="mermaid"></div>

        <!-- Legend positioned at the top-right corner -->
        <div class="position-absolute top-0 end-0 p-3">
            <div class="d-flex flex-column">
                <div class="d-flex align-items-center mb-2">
                    <div style="width: 20px; height: 20px; background-color: #A2C2E0; border: 2px solid #8DA6C8; margin-right: 5px;"></div>
                    <span>Source</span>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <div style="width: 20px; height: 20px; background-color: #D1B6E4; border: 2px solid #B18BC9; margin-right: 5px;"></div>
                    <span>Dataset</span>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <div style="width: 20px; height: 20px; background-color: #FFE1D6; border: 2px solid #FFB19D; margin-right: 5px;"></div>
                    <span>Report</span>
                </div>
                <!-- Legend item 4 -->
                <div class="d-flex align-items-center mb-2">
                    <div style="width: 20px; height: 20px; background-color: #BFD8B8; border: 2px solid #A3C29C; margin-right: 5px;"></div>
                    <span>Dashboard</span>
                </div>
                <!-- Legend item 5 -->
                <div class="d-flex align-items-center mb-2">
                    <div style="width: 20px; height: 20px; background-color: #F6C1C1; border: 2px solid #F1A8A8; margin-right: 5px;"></div>
                    <span>Dataflow</span>
                </div>
                <!-- Legend item 6 -->
                <div class="d-flex align-items-center mb-2">
                    <div style="width: 20px; height: 20px; background-color: #F5E1A4; border: 2px solid #E6C476; margin-right: 5px;"></div>
                    <span>Pipeline</span>
                </div>
            </div>
        </div>
    </div>  
</div>